import { Routes} from '@angular/router';
import {NotFoundComponent} from './shared/pages/not-found/not-found.component';
import {MaintenanceWorkComponent} from './shared/pages/maintenance-work/maintenance-work.component';
import {IdentificationComponent} from './project/pages/identification/identification.component';
import {ConsentDeclarationComponent} from './project/pages/consent-declaration/consent-declaration.component';
import {ROUTESURL} from  './app-routing.model'
import {routesH} from 'build/project/route.model';

export const routes: Routes = [
   {
      path: '',
      pathMatch: 'full',
      redirectTo: 'login'
   },
   {
      path: ROUTESURL.LOGIN,
      component: IdentificationComponent
   },
   {
      path: ROUTESURL.DECLARATION,
      component: ConsentDeclarationComponent
   },
   {
      path: ROUTESURL.MAINTENANCEWORK,
      component: MaintenanceWorkComponent
   },
   {
      path: ROUTESURL.NOTFOUND,
      component: NotFoundComponent
   },
   ...routesH, // Muss bleiben, wegen Testingroutes
   {
      path: '**',
      pathMatch: 'full',
      redirectTo: 'not-found'
   }
];
